module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.e7e8e14d.eot";